<template>
    <div v-if="!loading && item.has_to_join">
        <v-alert type="info" border="left" icon="mdi-monitor-account" text dense class="mb-2">
            <div class="d-flex justify-space-between align-center">
                <span>Join briefing.</span>
                <v-btn small @click="joinBriefing">Join</v-btn>
            </div>
        </v-alert> 
    </div>
</template>

<script>
import swal from 'sweetalert';

export default {
    data: () => ({
        item: {
            has_to_join: false,
        },
        loading: false
    }),
    methods: {
        getItem() {
            this.loading = true
            this.$axios.get(`/api/dashboard/hasToJoinBriefing`).then((resp) => {
                this.item = resp.data
            }).finally(() => this.loading = false)
        },
        joinBriefing() {
            swal({
                title: "Are you sure?",
                text: "This will mark you as present to todays briefing!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then((willJoin) => {
                if (willJoin) {
                    this.$axios.post(`/api/dashboard/joinBriefing`).then((resp) => {
                        // this.getItem()
                        this.item = resp.data.data
                    }).finally(() => {
                        // this.item.has_to_join = false
                        this.getItem()
                    })     
                }
            });
        },
    },
    mounted() {
        this.getItem()
    },
}
</script>

<style>

</style>